export const dashboard = () => {
    console.info("*-*-* dashboard *-*-*");

};
